import React, { useEffect } from "react"
import { Row, Col, Typography, Space, Avatar, Flex } from "antd"
import { UserOutlined } from "@ant-design/icons"
import styles from "./PartnerPage.module.css"
import Logo from "components/common/Logo"
import { LocationIcon } from "icons"
import { useDispatch, useSelector } from "react-redux"
import { getPartner } from "store/partner"
import { useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import FirstLoading from "modules/loader-watchers/FirstLoading"
import useLoaderWatchers from "modules/loader-watchers/hooks/useLoaderWatchers"
import TripsList from "./TripsList"

const { Title, Text, Paragraph } = Typography

const PartnerPage = () => {
  const { partnerSlug } = useParams()
  useLoaderWatchers({ watchers: ["partner"] })
  const dispatch = useDispatch()
  const { data } = useSelector((state) => state.partner)
  const { city, state, guides, business_name, logo_url, description } = data?.partner || {}
  const { t } = useTranslation()

  useEffect(() => {
    if (partnerSlug) {
      dispatch(getPartner(partnerSlug))
    }
  }, [partnerSlug, dispatch])

  return (
    <FirstLoading name="partner">
      <div className="border-b ">
        <div className={`${styles.container}`} style={{ position: "sticky", top: 0, zIndex: 1000, backgroundColor: "#fff" }}>
          <Logo alt="Logo" width={35} height={35} wide />
        </div>
      </div>
      <div>
        {business_name ? (
          <>
            <div className={styles.header}>
              <div className={styles.container}>
                <Flex gap={20} align="middle">
                  <Avatar shape="square" size={80} src={logo_url} className={styles.partnerLogo} />
                  <div style={{ width: "calc(100% - 80px)" }}>
                    <Title level={2} className={styles.partnerHeading}>
                      {business_name}
                    </Title>
                    {description && <Paragraph className="m-0">{description}</Paragraph>}
                  </div>
                </Flex>

                <Row gutter={22} className={styles.contactRow} align="middle">
                  {Array.isArray(guides) && guides.length > 0 && (
                    <Col>
                      <Space size={4}>
                        <UserOutlined />
                        <Text>
                          {guides.length} {t("partner.trusted_guide")}
                        </Text>
                      </Space>
                    </Col>
                  )}

                  {(city || state) && (
                    <Col>
                      <Space size={4}>
                        <LocationIcon />
                        <Text>{[city, state].filter(Boolean).join(", ")}</Text>
                      </Space>
                    </Col>
                  )}
                </Row>
              </div>
            </div>

            <TripsList trips={data?.trips} />
          </>
        ) : (
          <div className={styles.container} style={{ padding: "48px 0", textAlign: "center" }}>
            <Typography.Title level={3}>{t("partner.no_partner")}</Typography.Title>
          </div>
        )}
      </div>
    </FirstLoading>
  )
}

export default PartnerPage
